import React from 'react'
import {PagingInfo} from '@elastic/react-search-ui'
import {Trans, useTranslation} from 'react-i18next'

import {ResultsOverviewText} from './styles'

const ResultTotal = ({lang, filter}) => {
  const {t} = useTranslation('common')

  function renderFilterText() {
    switch (filter) {
      case 'data':
        return (
          <>
            {' '}
            {t('header.filters.from')}{' '}
            <a href={t('header.filters.dataCatalogueLink')}>
              {t('header.filters.dataCatalogue')}
            </a>
          </>
        )
      case 'elaws':
        return (
          <div className="elaws-filter-text">
            {t('header.filters.eLawsText')}
            <a href={t('header.filters.eLawsLink')}>
              {t('header.filters.eLaws')}
            </a>
            .
          </div>
        )

      default:
        return ''
    }
  }

  return (
    <PagingInfo
      view={({start, end, searchTerm, totalResults}) => {
        if (searchTerm === null) {
          return ''
        }
        if (totalResults == 0) {
          return (
            <ResultsOverviewText data-testing="search-results-text">
              <Trans
                i18nKey="zeroResultsFor"
                values={{
                  searchTerm,
                }}
                components={{bold: <strong />}}
              />
              {renderFilterText()}
            </ResultsOverviewText>
          )
        } else if (totalResults == 1) {
          return (
            <ResultsOverviewText data-testing="search-results-text">
              <Trans
                i18nKey="displayOneResult"
                values={{
                  searchTerm,
                }}
                components={{bold: <strong />}}
              />
              {renderFilterText()}
            </ResultsOverviewText>
          )
        } else if (totalResults <= 20) {
          // return translation string for number of results between 2 and 20
          return (
            <ResultsOverviewText data-testing="search-results-text">
              <Trans
                i18nKey="displaySinglePageResults"
                values={{
                  totalResults: new Intl.NumberFormat(`${lang}-CA`).format(
                    totalResults,
                  ),
                  searchTerm,
                }}
                components={{bold: <strong />}}
              />
              {renderFilterText()}
            </ResultsOverviewText>
          )
        } else {
          if (filter === 'elaws') {
            totalResults = totalResults > 100 ? 100 : totalResults
          }
          return (
            // return translation string for > 20 results
            <ResultsOverviewText data-testing="search-results-text">
              <Trans
                i18nKey="displayMultipleResults"
                values={{
                  start: new Intl.NumberFormat(`${lang}-CA`).format(start),
                  end: new Intl.NumberFormat(`${lang}-CA`).format(end),
                  totalResults: new Intl.NumberFormat(`${lang}-CA`).format(
                    totalResults,
                  ),
                  searchTerm,
                }}
                components={{bold: <strong />}}
              />
              {renderFilterText()}
            </ResultsOverviewText>
          )
        }
      }}
    />
  )
}

export default ResultTotal
